export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGOUT = "LOGOUT";
export const LOGIN = "LOGIN";
export const SET_PROFILE = "SET_PROFILE";
export const SET_AVATAR = "SET_AVATAR";
export const SET_ACCOUNTS = "SET_ACCOUNTS";
export const SET_REFCODE = "SET_REFCODE";
export const SET_APPCONFIG = "SET_APPCONFIG";
export const SET_AGENCY_DETAILS = "SET_AGENCY_DETAILS";
export const VERIFIED_ADDRESS = "VERIFIED_ADDRESS";
export const ACCEPT_DISCLOSURES = "ACCEPT_DISCLOSURES";
export const PHONE_VERIFIED = "PHONE_VERIFIED";
export const QUESTIONNAIRE = "QUESTIONNAIRE";
export const SENTIMENT_QUESTIONNAIRE = "SENTIMENT_QUESTIONNAIRE";
export const AGENCY_LINKED = "AGENCY_LINKED";
